<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>{{ role }}</small>
    </div>

    <vs-dropdown vs-custom-content class="cursor-pointer">

      <div class="con-img ml-3">
        <!-- <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" /> -->
        <vs-avatar />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="perfil">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Mi perfil</span>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Salir</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    role () {
      const r = this.$store.state.AppActiveUser.userRole
      return r.substring(5)
    }
  },
  methods: {
    logout () {
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('accessToken')
      sessionStorage.removeItem('refreshToken')
      this.$store.dispatch('removeAppActiveUser', this.$store.state.AppActiveUser);

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/pages/login').catch(() => {})
    },
    perfil () {
      this.$router.push(`/usuarios/perfil/${this.activeUserInfo.uid}`).catch(() => {})
    }
  }
}
</script>
